import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Buyer, BuyerActionTypes, BuyerFailure, BuyerSuccess } from '../actions/buyerActions';

import { BuyerService } from '../../app/pages/buyer/buyer.service';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';

@Injectable()
export class BuyerEffects {

  constructor(
    private actions: Actions,
    private buyerService: BuyerService
  ) { }

  @Effect()
  Buyer: Observable<any> = this.actions
    .ofType(BuyerActionTypes.BUYER)
    .map((action: Buyer) => action)
    .switchMap(payload => {
      return this.buyerService.buyer().map((data) => {
         return new BuyerSuccess({ buyer: data.data });
      })
        .catch((error) => {
          return Observable.of(new BuyerFailure({ error: error }));
        });
    });

  @Effect({ dispatch: false })
  BuyerSuccess: Observable<any> = this.actions.pipe(
    ofType(BuyerActionTypes.BUYER_SUCCESS)
  );

  @Effect({ dispatch: false })
  BuyerFailure: Observable<any> = this.actions.pipe(
    ofType(BuyerActionTypes.BUYER_FAILURE)
  );
}
